import { pdpaApi } from "@api";
import { ArrowLeftColor, ComponentPrivacy, StyledPrivacy } from "@components";
import { IPdpa } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
export const PagePrivacy = () => {
    const { t } = useTranslation();
    const [pdpa, setPdpa] = useState<IPdpa[]>([]);
    const history = useHistory();
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    useEffect(() => {
        fetchNotice();
    }, []);
    const fetchNotice = async () => {
        const res = await pdpaApi.getOnformListByClientId({
            page: 1,
            limit: 10,
            userId: userInfo?._id,
        });
        if (res.data) {
            setPdpa(res.data.docs);
        }
    };

    return (
        <StyledPrivacy themeColor={themes?.themeColor!} color={themes?.themeColor!}>
            <header>
                <div className="back-arrow">
                    <ArrowLeftColor color={themes?.themeColor!} onClick={() => history.goBack()} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                <h4>{t("page.data_privacy")}</h4>
            </header>
            <article>
                <h5>{t("page.consent_marketing_purpose")}</h5>
                <p>{t("page.we_always_care_about_your_privacy")}</p>
                <p>{t("page.how_we_collect")}</p>
                <p>{t("page.research_anaylze")}</p>
                <p>{t("page.you_agree_let_us")}</p>
                <p>{t("page.right_to_withdraw_this_consent")}</p>
                <p>{t("page.please_further_read_our_Privacy")}</p>
                {pdpa.map((item, index) => (
                    <ComponentPrivacy item={item} key={index} callback={fetchNotice} />
                ))}
                <p>{t("page.if_you_do_not_give_consent")}</p>
            </article>
        </StyledPrivacy>
    );
};
